import ApiService from './ApiService.js'

export default {
  get (id, params = {}) {
    return ApiService.get('cultures', id, params)
  },

  find (params, subresource = '') {
    return ApiService.get('cultures', subresource, params)
  },

  post (payload) {
    return ApiService.post('cultures', { payload })
  },

  getGroups () {
    return ApiService.get('cultures', 'groups')
  }
}
